import { render } from "./FormBarang.vue?vue&type=template&id=779b198f"
import script from "./FormBarang.vue?vue&type=script&lang=js"
export * from "./FormBarang.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__